import React, { useState } from "react";
import { Loader } from "../../Common";

const CollapsibleCardItem = ({
  id,
  title,
  pass,
  tag,
  description,
  renderNode,
  loading,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleCollapse = () => {
    setIsOpen(!isOpen);
  };

  const statusContent = {
    false: (
      <span className="cross-icon" style={{ height: "20px", width: "20px" }}>
        {" "}
        <i className="bi bi-x"></i>{" "}
      </span>
    ),
    true: (
      <span className="tick-icon" style={{ height: "20px", width: "20px" }}>
        {" "}
        <i class="bi bi-check2"></i>
      </span>
    ),
    null: <i class="bi bi-slash-circle text-declined" style={{ height: "20px", width: "20px" }}></i>,
  };

  return (
    <div
      className="card card-items"
      style={{
        border: "none",
        borderBottom:
          "var(--bs-card-border-width) solid var(--bs-card-border-color)",
        borderRadius: "0",
        padding: "15px 21px 0",
      }}
    >
      <div
        className="d-flex justify-content-between align-items-center"
        data-bs-toggle="collapse"
        data-bs-target={`#${id}`}
        aria-expanded={isOpen}
        aria-controls={id}
        onClick={toggleCollapse}
      >
        <li className="list-inline-item d-inline-flex align-items-center gap-2">
          {pass !== null && loading ? <Loader /> : statusContent[pass]}
          <h4
            className="m-0"
            style={{
              fontSize: "15px",
              fontWeight: "700",
            }}
          >
            {title}
          </h4>
        </li>
        <div className="d-inline-flex align-items-center gap-2">
          <span
            className="article-table-tags bg-soft-secondary text-secondary justify-content-center"
            style={{ minWidth: "84px" }}
          >
            {tag}
          </span>
          <span
            class="article-table-tags text-secondary justify-content-center"
            style={{
              background: "var(--bs-card-border-color)",
              minWidth: "23px",
              minHeight: "23px",
            }}
          >
            <i
              className={`bi bi-chevron-down ${isOpen ? "rotate-180" : ""}`}
              style={{ transition: "transform 0.3s ease", fontSize: "10px" }}
            ></i>
          </span>
        </div>
      </div>
      <p
        className={`${!isOpen && "text-ellipsis-2"} mt-2`}
        style={{ color: "#919293", transition: "all 0.3s ease" }}
      >
        {description}
      </p>
      <div className="collapse" id={id}>
        {renderNode}
      </div>
    </div>
  );
};

export default CollapsibleCardItem;
